import { useMemo } from 'react';
import {
  SearchFilter,
  SearchFilterBase,
  SearchFilterBaseSections,
} from '../types';

const EMPTY_ITEMS: SearchFilter[] = [];

export function useFilterSections(
  filter?: SearchFilterBase,
  sections?: SearchFilterBaseSections
) {
  return useMemo(() => {
    if (!filter)
      return {
        mainItems: EMPTY_ITEMS,
        moreItems: EMPTY_ITEMS,
        sourceItems: EMPTY_ITEMS,
      };
    if (!filter.sections)
      return {
        mainItems: filter.items ?? EMPTY_ITEMS,
        moreItems: EMPTY_ITEMS,
        sourceItems: EMPTY_ITEMS,
      };
    const { main, more, source } = sections ?? filter.sections;
    const { items } = filter;
    const mainItems = main ? items?.slice(0, main) ?? EMPTY_ITEMS : EMPTY_ITEMS;
    const moreItems = more
      ? items?.slice(main, main + more) ?? EMPTY_ITEMS
      : EMPTY_ITEMS;
    const sourceItems = source
      ? items?.slice(main + (more ?? 0), main + (more ?? 0) + source) ??
        EMPTY_ITEMS
      : EMPTY_ITEMS;
    return { mainItems, moreItems, sourceItems };
  }, [filter, sections]);
}
